import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import { selectCmsControlByIdByPage } from "../../../../redux/slices/cmsSettingsSlice";
import IndividualRoleCard from "./IndividualRoleCard";
import { setAppShowRemainingForm } from "../../../../redux/slices/appSettingsSlice";

const ConnectedIndividualRoleCard = ({ controlId, ...props }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const dispatch = useDispatch();
    const { handleChange } = useFormikContext();
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );
    const {
        options: {
            registrationRole: {
                individualRegistrationDescription,
                individualRegistrationLabel = "As an Individual",
            },
        },
    } = control;
    const title = individualRegistrationLabel;
    const description = individualRegistrationDescription;

    const handleIndividualRoleChange = (e) => {
        if (e.target.checked) {
            dispatch(setAppShowRemainingForm(true));
        } else {
            dispatch(setAppShowRemainingForm(false));
        }
        handleChange(e);
    };

    const individualRoleCardProps = {
        title,
        description,
        handleChange: handleIndividualRoleChange,
        ...props,
    };

    return <IndividualRoleCard {...individualRoleCardProps} />;
};

ConnectedIndividualRoleCard.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedIndividualRoleCard;
